import React, { Component } from "react";
import {Table, Glyphicon, OverlayTrigger} from 'react-bootstrap';
import {format, toInt, getTimeInIST, popover, handleApproveStoreDeliveryChange, format_fancy} from '../Utils'
import moment from 'moment';
import '../css/storedelivery.css';
import { DeliveryService } from "../Services/DeliveryService";
import { UserService } from "../Services/UserService";

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { RowCountOptions } from "../Config";
import TablePagination from '@material-ui/core/TablePagination';
import classnames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Constants } from "../Constants";
import { ROLES } from "../Roles";

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
    },
  });

class StoreDeliveryPendingApproval extends Component {

    constructor(props) {
      super(props);
      this.state = {
        show : false,
        data: [],
        storeDeliveryMap: new Map(),
        storeMap: new Map(),
        current_rows: [],
        modal: {store: {}, deliveries : []},
        storeList: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,
        columns : [
            { id: 'store_name', numeric: false, disablePadding: false, label: 'Store' , sortable: true },
            { id: 'flat', numeric: false, disablePadding: false, label: 'Address', sortable: true  },
            { id: 'invoice_no', numeric: false, disablePadding: false, label: 'Invoice No', sortable: true  },
            { id: 'po_no', numeric: false, disablePadding: false, label: 'PO No', sortable: false  },
            { id: 'product_qty', numeric: false, disablePadding: false, label: 'Issued Qty', sortable: false  },
            { id: 'total_amount', numeric: false, disablePadding: false, label: 'Total Amount', sortable: true  },
            { id: 'revised_delivered_count', numeric: false, disablePadding: false, label: 'Delivered Count', sortable: true  },
            { id: 'revised_returned_count', numeric: false, disablePadding: false, label: 'Returned Count', sortable: true  },
            { id: 'delivery_date', numeric: false, disablePadding: false, label: 'Delivery Date', sortable: true  },
            { id: 'actions', numeric: false, disablePadding: false, label: '', sortable: false  },
        ],
        order: 'asc',
        orderBy: 'store_name',

        selected_store: "-1",
        startDate: moment().subtract(14, "days"),
        endDate: moment(),
      }

      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.showDetails = this.showDetails.bind(this);
    }

    componentWillMount(){
        this.props.isLoading(true);
        let store_id = this.state.selected_store === "-1" ? undefined : this.state.selected_store;
        DeliveryService.getTotalCountPendingApproval(store_id, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format))
        .then((data) => {
            console.log(data);
            this.setState({
                totalItems: toInt(data.count),
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
            });
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    componentDidMount(){
        this.props.setTitle('Store Deliveries Pending Approval');
        this.fetchStoreList();
        this.fetchData(0, this.state.numItemsPerPage);
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
    
        if (this.state.orderBy === property && this.state.order === 'desc') {
          order = 'asc';
        }
    
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    }

    fetchStoreList(){
        UserService.getStoreList(0, 10000, '', '', '', '0,1,2')
        .then((data) => {
            console.log(data);
            let store_names = data.users.map((w) => (
                <MenuItem key={w.id} value={w.id}>{w.store_name}</MenuItem>
            ));   
            store_names.unshift(<MenuItem key={"-1"} value={"-1"}>All Stores</MenuItem>);
            this.setState({storeList: data.users, store_names: store_names});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchData(start, numberItems, showLoader = true){
        let storeDeliveryMap = new Map(), storeMap = new Map(), current_rows = [];
        if(showLoader)
            this.props.isLoading(true);
        let store_id = this.state.selected_store === "-1" ? null : this.state.selected_store;
        DeliveryService.getTotalCountPendingApproval(store_id, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format))
        .then((data) => {
            console.log(data);
            this.setState({
                totalItems: toInt(data.count),
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
            });
            DeliveryService.getDeliveryPendingApproval(start, numberItems, store_id, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format))
            .then((data) => {
                console.log(data);
                if(data.delivery_schedule && data.delivery_schedule.length > 0){
                    
                    data.delivery_schedule.forEach(element => {
                        let a = [], b = {};
                        if(storeMap.has(element.id + element.invoice_no)){
                            b = storeMap.get(element.id + element.invoice_no);
                            b.product_qty += toInt(element.product_qty);
                            b.revised_delivered_count += toInt(element.revised_delivered_count);
                            b.total_amount += parseFloat(element.total_amount);
                            b.delivered_count += toInt(element.delivered_count);
                            b.returned_count += toInt(element.returned_count);
                            b.revised_returned_count += toInt(element.revised_returned_count);
                            b.replaced_count += toInt(element.replaced_count);
                            b.delivery_date = element.delivery_date;
                            b.invoice_no = element.invoice_no;
                        } else {
                            b.id = element.id;
                            b.invoice_no = element.invoice_no;
                            b.store_name = element.store_name;
                            b.name = element.name;
                            b.mobile_no = element.mobile_no;
                            b.flat = element.flat;
                            b.po_no = element.po_no;
                            b.product_qty = toInt(element.product_qty);
                            b.revised_delivered_count = toInt(element.revised_delivered_count);
                            b.total_amount = parseFloat(element.total_amount);
                            b.delivered_count = toInt(element.delivered_count);
                            b.returned_count = toInt(element.returned_count);
                            b.revised_returned_count = toInt(element.revised_returned_count);
                            b.replaced_count = toInt(element.replaced_count);
                            b.delivery_date = element.delivery_date;
                            b.schedule_date = element.schedule_date;
                            b.route_id = element.route_id;
                            b.invoice_url = element.invoice_url;
                            b.credit_note_url = element.credit_note_url;
                            b.transactions = element.transactions;
                            b.approval_pending = element.approval_pending;
                            b.approver_user_id = element.approver_user_id;
                            b.approver_name = element.approver_name;
                            b.delivery_agent_id = element.delivery_agent_id;
                            b.geo_location = element.geo_location;
                        }
                        storeMap.set(element.id + element.invoice_no, b);

                        if(storeDeliveryMap.has(element.id)){
                            a = storeDeliveryMap.get(element.id);
                        }
                        a.push(element);
                        storeDeliveryMap.set(element.id , a);
                    });
                    storeMap.forEach((value, key, map) => {
                        current_rows.push(
                            <DeliveryDetails 
                                key={key} 
                                user={value} 
                                showDetails={this.showDetails}
                                canApprove={this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)}/>
                        );
                    });
                }
                this.setState({
                    current_rows: current_rows, data: data.delivery_schedule, storeMap : storeMap, storeDeliveryMap: storeDeliveryMap, message: data.delivery_schedule.length > 0 ? "" : "No Deliveries Pending Approval"
                });
                if(showLoader)
                    this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                if(showLoader)
                    this.props.isLoading(false);
            });
        })
        .catch(error => {
            console.log(error);
        });
    }

    handleSelect = (eventKey, e) => {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow = (newCurrentPage) => {
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    showDetails(e, user){
        let deliveries = [];
        this.state.storeDeliveryMap.get(user.id).forEach((element, index) =>{
            if(user.invoice_no === element.invoice_no){
                deliveries.push(<ProductDeliveryDetails key={element.id + index} delivery={element}/>);
            }
        });
        this.setState({modal: {store: user, deliveries: deliveries}});
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleStoreSelection = (e) => {
        this.setState({selected_store: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeStartDate = (date) => {
        console.log(date);
        this.setState({
            startDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleApprove = () => {
        if(this.state.modal.store && this.state.modal.deliveries.length > 0){
            this.props.showConfirmDialog(`Confirm Approval for Store ${this.state.modal.store.store_name}?`, undefined, () =>{
                handleApproveStoreDeliveryChange(this.state.modal.store.invoice_no, this.props.user.id, {'user-id' : this.props.user.id, 'user-name': this.props.user.name }, (data) => {
                    console.log(data);
                    this.props.closeConfirmDialog();
                    if(data.success){
                        this.handleClose();
                        this.props.showSnackBar('Approved', 'success');
                        this.resendInvoice(undefined, this.state.modal.store, `Regenerate and re-send invoice for ${this.state.modal.store.store_name}?`);
                        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                    } else {
                        this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                    }
                }, (error) => {
                    console.log(error);
                })
                // let body = { invoice_no: this.state.modal.store.invoice_no, approver_user_id: this.props.user.id };
                // DeliveryService.approveDeliveryChange(body)
                // .then((data) => {
                    
                // });
            });
        }
    }

    resendInvoice(e, user, msg){
        if(e){
            e.preventDefault();
        }
        if(user.invoice_no){
            this.props.showConfirmDialog(msg ? msg : `Confirm re-send invoice for ${user.store_name}?`, undefined, () =>{
                let body = { user_id: user.id, schedule_date: user.schedule_date, route_id: user.route_id, invoice_no: user.invoice_no };
                DeliveryService.resendInvoice(body, Constants.STORE)
                .then((data) => {
                    console.log(data);
                    this.props.closeConfirmDialog();
                    if(data.success){
                        this.props.showSnackBar('Invoice sent successfully', 'success');
                    } else {
                        this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                    }
                })
                .catch(() => {
                    this.props.closeConfirmDialog();
                    console.log("Error Occurred while resending Invoice");
                    this.props.showSnackBar('Something went wrong. Please try again later or contact the admin', 'error');
                });
            });
        }
    }
    
    render() {
        let message = this.state.message;
        const { classes } = this.props;
        return ( 
            <div className="Home" style={{marginTop: 32}}>
                <div align="left">
                    <FormControl variant="outlined" className={classnames(classes.formControlLeft, classes.formControl)}>
                        <InputLabel
                            ref={ref => {
                            this.InputLabelRef = ref;
                            }}
                            htmlFor="outlined-warehouse-simple"
                        >
                            Store
                        </InputLabel>
                        <Select
                            value={this.state.selected_store}
                            onChange={this.handleStoreSelection}
                            input={
                            <OutlinedInput
                                labelWidth={80}
                                name="Store"
                                id="outlined-warehouse-simple"
                            />
                            }
                        >
                            {this.state.store_names}
                        </Select>
                    </FormControl>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                    <DatePicker
                            margin="normal"
                            label="From"
                            value={this.state.startDate}
                            onChange={this.handleChangeStartDate}
                            format='DD MMM YYYY'
                            maxDate={this.state.endDate}
                            variant="dialog"
                            inputVariant="outlined"
                            className={classes.formControl}
                            style={{ height: "100%", marginTop: "24px"}}
                        />
                        <DatePicker
                            margin="normal"
                            label="To"
                            value={this.state.endDate}
                            onChange={this.handleChangeEndDate}
                            format='DD MMM YYYY'
                            variant="dialog"
                            inputVariant="outlined"
                            className={classes.formControl}
                            style={{ height: "100%", marginTop: "24px"}}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                { message &&
                    <div style={{color:"red", paddingTop:50}}>{message}</div>
                }
                <div className="container">
                    { !this.props.loading && !message &&
                        <Paper className={this.props.classes.root} style={{width: "100%", marginTop: "5px", paddingLeft: "5px", paddingRight: "5px"}}>
                            <Table striped condensed hover responsive>
                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.sortBy}
                                    rows ={this.state.columns} />
                                <TableBody>
                                {this.state.current_rows}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={RowCountOptions}
                                component="div"
                                count={this.state.totalItems}
                                rowsPerPage={this.state.numItemsPerPage}
                                page={this.state.currentPageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                        </Paper>
                    }
                </div>
                <DialogMUI
                    disableBackdropClick
                    open={this.state.show}
                    onClose={this.handleClose}
                    fullWidth={true}
                    maxWidth = {'lg'}
                    style={{paperWidthSm: '17'}}
                    aria-labelledby="responsive-dialog-title"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">{`Delivery Details - ${this.state.modal.store.store_name} ${this.state.modal.store.invoice_no ? "[Invoice: "+this.state.modal.store.invoice_no+"]" : ""}`}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <Divider />
                                <Table striped condensed hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Invoice No</th>
                                            <th>Product Name</th>
                                            <th>Issued Qty</th>
                                            <th>Total Amount</th>
                                            <th>Delivered Count</th>
                                            <th>Returned Count</th>
                                            <th>Reason</th>
                                            <th>Delivery Date</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{textAlign: "left"}}>
                                        {this.state.modal.deliveries}
                                    </tbody>
                                </Table>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleApprove} color="secondary" autoFocus>
                                Approve
                            </Button>
                            <Button onClick={this.handleClose} color="primary" autoFocus>
                                Close
                            </Button>
                        </DialogActions>
                </DialogMUI>
            </div>
        );
    }
}

class DeliveryDetails extends Component {
    
    render(){
      const user = this.props.user;
      const canApprove = this.props.canApprove;
      return (
        <tr>
            <td>{user.store_name}</td>
            <td>{user.flat}</td>
            <td>{user.invoice_no ? user.invoice_no : "-"}</td>
            <td>{user.po_no}</td>
            <td>{user.product_qty}</td>
            <td>{Math.round(user.total_amount)}</td>
            <td>{((user.delivered_count !== 0 || user.revised_delivered_count !== 0) && user.delivered_count  !== user.revised_delivered_count) ? (<span><strike style={{color: 'red'}}>{user.delivered_count}</strike><br/>{user.revised_delivered_count}</span>) : user.delivered_count}</td>
            <td>{((user.returned_count !== 0 || user.revised_returned_count !== 0) && user.returned_count !== user.revised_returned_count) ? (<span><strike style={{color: 'red'}}>{user.returned_count}</strike><br/>{user.revised_returned_count}</span>) : user.returned_count}</td>
            <td>{user.delivery_date ? getTimeInIST(user.delivery_date).format(format_fancy) : "-"}</td>
            <td style={{textAlign: "center", paddingRight: 30 }}>
                {
                    canApprove && (
                        <OverlayTrigger overlay={popover("Approve the Changes")}>
                            <Glyphicon glyph="ok" onClick={(e) => this.props.showDetails(e, user)}/>
                        </OverlayTrigger>
                    )
                }
            </td>
        </tr>
      );
    }
}

class ProductDeliveryDetails extends Component {

    render(){
      const delivery = this.props.delivery;
    
      return (
        <tr>
            <td>{delivery.delivery_date ? (delivery.invoice_no ? delivery.invoice_no : '-') : ''}</td>
            <td>{delivery.product_name}</td>
            <td>{delivery.product_qty}</td>
            <td>{delivery.total_amount}</td>
            <td>{(delivery.delivered_count !== 0 || toInt(delivery.revised_delivered_count) !== 0) && delivery.delivered_count !== delivery.revised_delivered_count ? (<span><strike style={{color: 'red'}}>{delivery.delivered_count}</strike><br/> {delivery.revised_delivered_count}</span>) : delivery.delivered_count}</td>
            <td>{(delivery.returned_count !== 0 || toInt(delivery.revised_returned_count) !== 0) && delivery.returned_count !== delivery.revised_returned_count ? (<span><strike style={{color: 'red'}}>{delivery.returned_count}</strike><br/> {delivery.revised_returned_count}</span>) : delivery.returned_count}</td>
            <td>{delivery.reason ? delivery.reason : "-"}</td>
            <td>{delivery.delivery_date ? getTimeInIST(delivery.delivery_date).format(format_fancy) : "-"}</td>
        </tr>
      );
    }
}

export default withStyles(styles)(StoreDeliveryPendingApproval);